module.exports = __webpack_public_path__ + "static/media/sn.bd3852d7.jpeg";